// src/components/common/CancelButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleXmark } from '@/icons';
import './CancelButton.css';

interface CancelButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const CancelButton: React.FC<CancelButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`cancel-button ${className}`}
    >
      <FontAwesomeIcon icon={faRectangleXmark} /> Fechar
    </button>
  );
};

export default CancelButton;
